import React from 'react';
import { motion } from 'framer-motion';
interface ProgressBarProps {
  current: number;
  total: number;
}
export function ProgressBar({
  current,
  total
}: ProgressBarProps) {
  const percentage = Math.min(100, Math.max(0, current / total * 100));
  return <div className="w-full max-w-md mx-auto relative z-10" data-id="element-1525" data-mp="8gb4p4210fnv">
      <div className="flex justify-between items-end mb-3 font-mono text-xs tracking-wider" data-id="element-1526" data-mp="4hv94brvpyyu">
        <span className="text-gray-400 uppercase flex items-center gap-2" data-id="element-1527" data-mp="3cxotj1pbzul6">
          <span className="w-1.5 h-1.5 bg-[#FF0000] rounded-full animate-pulse" data-id="element-1528" data-mp="37y2fwr5lccbu" />
          Sequence {current}/{total}
        </span>
        <span className="text-[#FF0000] font-bold tabular-nums" data-id="element-1529" data-mp="3lpqpamoggmp4">
          {Math.round(percentage)}%
        </span>
      </div>

      <div className="w-full bg-white/5 border border-white/10 rounded-full h-2 overflow-hidden backdrop-blur-sm relative" data-id="element-1530" data-mp="3gw4b2q2n8ar7">
        <motion.div className="h-full bg-[#FF0000] relative rounded-full" initial={{
        width: 0
      }} animate={{
        width: `${percentage}%`
      }} transition={{
        type: 'spring',
        stiffness: 50,
        damping: 15,
        mass: 1
      }} data-id="element-1531" data-mp="2p71abk9ytijb">
          {/* Glowing edge */}
          <div className="absolute right-0 top-0 bottom-0 w-2 bg-white/50 blur-[2px]" data-id="element-1532" data-mp="1hj3ziv7zz48a" />

          {/* Shimmer effect */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent w-full -translate-x-full animate-[shimmer_2s_infinite]" data-id="element-1533" data-mp="jvv68e1r8qvq" />
        </motion.div>
      </div>
    </div>;
}